module.exports = __webpack_public_path__ + "static/media/projectsNavbar.5b4dc3d8.svg";